var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3H4.16667C3.72464 3 3.30072 3.17559 2.98816 3.48816C2.67559 3.80072 2.5 4.22464 2.5 4.66667V8.83333C2.5 9.27536 2.67559 9.69928 2.98816 10.0118C3.30072 10.3244 3.72464 10.5 4.16667 10.5H7.5C7.94203 10.5 8.36595 10.3244 8.67851 10.0118C8.99107 9.69928 9.16667 9.27536 9.16667 8.83333V4.66667C9.16667 4.22464 8.99107 3.80072 8.67851 3.48816C8.36595 3.17559 7.94203 3 7.5 3ZM4.16667 8.83333V4.66667H7.5V8.83333H4.16667Z",
    fill: "#8E97A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3H12.5C12.058 3 11.634 3.17559 11.3215 3.48816C11.0089 3.80072 10.8333 4.22464 10.8333 4.66667V7.16667C10.8333 7.60869 11.0089 8.03262 11.3215 8.34518C11.634 8.65774 12.058 8.83333 12.5 8.83333H15.8333C16.2754 8.83333 16.6993 8.65774 17.0118 8.34518C17.3244 8.03262 17.5 7.60869 17.5 7.16667V4.66667C17.5 4.22464 17.3244 3.80072 17.0118 3.48816C16.6993 3.17559 16.2754 3 15.8333 3ZM12.5 7.16667V4.66667H15.8333V7.16667H12.5Z",
    fill: "#8E97A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.1667H4.16667C3.72464 12.1667 3.30072 12.3423 2.98816 12.6548C2.67559 12.9674 2.5 13.3913 2.5 13.8333V16.3333C2.5 16.7754 2.67559 17.1993 2.98816 17.5118C3.30072 17.8244 3.72464 18 4.16667 18H7.5C7.94203 18 8.36595 17.8244 8.67851 17.5118C8.99107 17.1993 9.16667 16.7754 9.16667 16.3333V13.8333C9.16667 13.3913 8.99107 12.9674 8.67851 12.6548C8.36595 12.3423 7.94203 12.1667 7.5 12.1667ZM4.16667 16.3333V13.8333H7.5V16.3333H4.16667Z",
    fill: "#8E97A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.5H12.5C12.058 10.5 11.634 10.6756 11.3215 10.9882C11.0089 11.3007 10.8333 11.7246 10.8333 12.1667V16.3333C10.8333 16.7754 11.0089 17.1993 11.3215 17.5118C11.634 17.8244 12.058 18 12.5 18H15.8333C16.2754 18 16.6993 17.8244 17.0118 17.5118C17.3244 17.1993 17.5 16.7754 17.5 16.3333V12.1667C17.5 11.7246 17.3244 11.3007 17.0118 10.9882C16.6993 10.6756 16.2754 10.5 15.8333 10.5ZM12.5 16.3333V12.1667H15.8333V16.3333H12.5Z",
    fill: "#8E97A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f9b27aa78f1a50be656e540da4ce14a0.svg";
export { ForwardRef as ReactComponent };